<template>
	<div>
		<span v-if="label != ''" class="birthDate__label">
			{{ label }}
			<span v-if="mandatory" class="birthDate__mandatory">*</span>
		</span>
		<div class="birthDate" :getDate="getDate">
			<Select
				v-bind:optionItems="years"
				v-model="selectedYear"
				:hasError="hasError"
				:defaultSelectedValue="preSelectedYear"
				:disabled="false"
				:isDisabled="isLocked"
				preSelectedOptionTitle="Välj år"
				@input="sendBirthDate(val)"
			/>
			<Select
				v-bind:optionItems="months"
				v-model="selectedMonth"
				:hasError="hasError"
				:disabled="false"
				:defaultSelectedValue="preSelectedMonth"
				:isDisabled="isLocked"
				preSelectedOptionTitle="Välj månad"
				@input="sendBirthDate(val)"
			/>
			<Select
				v-bind:optionItems="days"
				v-model="selectedDay"
				:hasError="hasError"
				:disabled="false"
				:defaultSelectedValue="preSelectedDay"
				:isDisabled="isLocked"
				preSelectedOptionTitle="Välj dag"
				@input="sendBirthDate(val)"
			/>
		</div>
		<span v-if="errorMessage != ''" class="birthDate__error">
			{{ errorMessage }}
		</span>
	</div>
</template>

<script>
import Select from '../atoms/Select.vue'
import moment from 'moment'

export default {
	name: 'BirthDate',
	data() {
		return {
			val: '',
			years: [{ id: '', text: '' }],
			months: [{ id: '', text: '' }],
			days: [{ id: '', text: '' }],
			daysInMonth: 31,
			selectedYear: '',
			selectedMonth: '',
			selectedDay: '',

			//Pre-selected values
			preSelectedYear: '',
			preSelectedMonth: '',
			preSelectedDay: '',

			dateLangArray: []
		}
	},
	components: {
		Select
	},
	props: {
		getDate: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		mandatory: {
			type: Boolean,
			default: false
		},
		errorMessage: {
			type: String,
			default: ''
		},
		hasError: {
			type: Boolean,
			default: false
		},
		isLocked: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		setYears(year) {
			const yearList = []
			const years = []
			const currentYear = new Date().getFullYear()
			let startYear = 1920

			//If set year has a date string then set year
			if (moment(year).isValid()) {
				this.preSelectedYear = moment(year).year().toString()
			}

			while (startYear <= currentYear) {
				yearList.push(startYear++)
			}

			yearList.forEach(function (item) {
				years.push({ id: item, text: item })
			})
			this.years = years.reverse()
		},

		//Set the current month
		setMonths(month) {
			const monthsList = this.dateLangArray
			const months = []
			//let startMonth = 0

			monthsList.forEach(function (item, index) {
				months.push({ id: index + 1, text: item })
			})

			//If set year has a date string then set year
			if (moment(month).isValid()) {
				this.preSelectedMonth = months[moment(month).month()].id.toString()
			}

			this.months = months
		},

		//Set the current amount of days for the selected month
		setDays(day) {
			const daysList = []
			const days = []
			let startDay = 1
			let numberOfDays = day

			//If set day has a date string then set day
			if (moment(day).isValid() && !Number.isInteger(day)) {
				numberOfDays = moment(day).daysInMonth()
				let getDayFromMoment = moment(day).format('DD')

				this.selectedDay = getDayFromMoment
				this.preSelectedDay = getDayFromMoment
			}

			while (startDay <= numberOfDays) {
				daysList.push(startDay++)
			}

			daysList.forEach(function (item) {
				let itemFormat = item
				let itemText = item
				if (item < 10) {
					itemText = '0' + item
				}
				days.push({ id: itemFormat, text: itemText })
			})

			this.days = days
		},
		sendBirthDate() {
			let correctedMonth = ''
			let correctedDay = ''
			const dateValue = moment()

			dateValue.set('months', this.selectedMonth - 1)
			this.setDays(dateValue.daysInMonth())

			correctedMonth = this.selectedMonth
			correctedDay = this.selectedDay

			if (this.selectedMonth <= 9) {
				correctedMonth = '0' + this.selectedMonth
			}

			if (this.selectedDay <= 9) {
				correctedDay = '0' + this.selectedDay
			}

			const val = this.selectedYear + '-' + correctedMonth + '-' + correctedDay

			if (val.length > 8) {
				this.$emit('getBirthdate', val)
			}
		},
		setDate(val) {
			const date = moment(val)
			if (date.isValid()) {
				let parts = val.split('-')
				const year = parseInt(parts[0], 10)
				const month = parseInt(parts[1], 10)
				const day = parseInt(parts[2], 10)

				this.selectedYear = year.toString()
				this.selectedMonth = month.toString()
				this.selectedDay = day.toString()
			}
		}
	},
	created() {
		this.dateLangArray = this.$t('datepicker.monthListLong')
		this.setYears(this.getDate)
		this.setMonths(this.getDate)
		this.setDays(this.getDate)
		this.setDate(this.getDate)
	}
}
</script>

<style scoped lang="scss">
.birthDate {
	display: flex;
	margin-left: 0;
	margin-right: 0;
	flex-wrap: wrap;
	@include for-tablet-portrait-up {
		margin-left: -$spacing2;
		margin-right: -$spacing2;
		flex-wrap: nowrap;
		margin-bottom: 15px;
	}

	> * {
		margin: 0;
		@include for-tablet-portrait-up {
			margin: 0 $spacing2;
		}
	}
	.select__container {
		width: calc(65% - 20px);
		margin-right: 20px;
		&:last-child {
			width: 35%;
			margin-right: 0;
		}
		&:first-child {
			width: 100%;
			margin-right: 0;
		}

		@include for-phone-only {
			margin-bottom: 20px;
		}
		@include for-tablet-portrait-up {
			width: 33%;
			margin-right: 0;
			&:last-child,
			&:first-child {
				width: 33%;
				margin-right: 0;
			}
		}
	}
	&__label {
		display: block;
		color: #697791;
		font-family: Saira;
		font-size: 15px;
		line-height: 24px;
		margin-bottom: 5px;
		@include for-tablet-portrait-up {
			//padding-top: 20px;
		}
	}
	&__mandatory {
		font-size: 15px;
		color: $colorRed;
		margin-left: -3px;
	}
	&__error {
		color: $colorRed;
		display: inline-block;
		font-size: 15px;
		line-height: 15px;
		margin-top: 15px;
	}
}
</style>
